export const POORVIKA_URL = "https://onmoplus.com/shop/poorvika";
export const FLIPKART_URL = "https://onmoplus.com/shop/flipkart";

export type PaywallVariant = "newUser" | "founder" | "renewal";

export type PaywallHeader = { title: string; subtitle: string };

export const PAYWALL_HEADER: Record<PaywallVariant, PaywallHeader> = {
  newUser: {
    title: "Paywall_Unlock the gamer in you",
    subtitle: "Paywall_Everything you need to start playing",
  },
  founder: {
    title: "Paywall_Founder's Access Renew Deal",
    subtitle: "Paywall_Reserved just for you. Lock in your discounted rate now",
  },
  renewal: {
    title: "Paywall_Keep the Game Going",
    subtitle: "Paywall_Renew your access and keep playing instantly",
  },
};

export const separateThousands = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
